export class QRIcon {
  // Colores
  public static readonly COLOR_WHITE: string = 'white';
  public static readonly COLOR_PRIMARY_500: string = 'primary-500';
  public static readonly COLOR_PRIMARY_550: string = 'primary-550';
  public static readonly COLOR_PRIMARY_700: string = 'primary-700';
  public static readonly COLOR_PRIMARY_900: string = 'primary-900';
  public static readonly COLOR_PRIMARY_100: string = 'primary-100';
  public static readonly COLOR_PRIMARY_300: string = 'primary-300';
  public static readonly COLOR_GREY_900: string = 'grey-900';
  public static readonly COLOR_GREY_800: string = 'grey-800';
  public static readonly COLOR_GREY_700: string = 'grey-700';
  public static readonly COLOR_GREY_600: string = 'grey-600';
  public static readonly COLOR_GREY_500: string = 'grey-500';
  public static readonly COLOR_GREY_450: string = 'grey-450';
  public static readonly COLOR_GREY_400: string = 'grey-400';
  public static readonly COLOR_GREY_300: string = 'grey-300';
  public static readonly COLOR_GREY_200: string = 'grey-200';
  public static readonly COLOR_GREY_100: string = 'grey-100';
  public static readonly COLOR_ERROR_700: string = 'error-700';
  public static readonly COLOR_ERROR_900: string = 'error-900';
  public static readonly COLOR_SUCCESS_500: string = 'success-500';
  public static readonly COLOR_SUCCESS_700: string = 'success-700';
  public static readonly COLOR_WARNING_700: string = 'warning-700';
}
